import React from 'react'
import { useEffect, useState } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Button from '../../../../Core/Button/Button'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import Table from './Table'
import {
    usePostSupplierListMutation,
    useTotalSupplierCountMutation,
} from "../../../../store/api/itemapi";

import { useGetSupplierPosMutation, useGetPOItemsForASNMutation, useCreateASNMutation, useSubmitASNMutation, useUpdateASNMutation, useGetASNDetailsQuery } from '../../../../store/api/asnApi'
import PurchaseOrderPopup from '../Components/PurchaseOrderPopup'
import Attachment from '../../../../utils/Attachment'
function Asnform({ asn_id }) {
    const [updateASN] = useUpdateASNMutation();

    const [createASN] = useCreateASNMutation();

    const [submitASN] = useSubmitASNMutation();

    const [postSupplierList] = usePostSupplierListMutation();
    const [totalSupplierCount] = useTotalSupplierCountMutation();
    const [
        getSupplierPos,
        { isLoading: isSupplierLoading, data: supplierPOsData, error: supplierError }
    ] = useGetSupplierPosMutation();
    const [getPOItemsForASN] = useGetPOItemsForASNMutation();
    const [supplierData, setSupplierData] = useState(null);
    const [selectedsupplierData, setselectedSupplierData] = useState(null);
    const [supplierPOs, setSupplierPOs] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedPOs, setSelectedPOs] = useState([]);
    const [asnItems, setAsnItems] = useState([]);
    const [asnId, setAsnId] = useState(null);


    useEffect(() => {
        const fetchSuppliers = async () => {
            try {
                const countRes = await totalSupplierCount().unwrap();
                const totalCount = countRes.message;

                const supplierRes = await postSupplierList({
                    start: 0,
                    limit: totalCount,
                    filters: [],
                    fields: [],
                }).unwrap();

                setSupplierData(supplierRes);
            } catch (err) {
                console.error("Error fetching suppliers", err);
            }
        };

        fetchSuppliers();
    }, []);


    const supplierOptions = supplierData?.data?.map(supplier => ({
        label: supplier.supplier_name,
        value: supplier.supplier_name
    })) || [];

    const handleFetchSupplierPOs = () => {
        if (selectedsupplierData) {
            getSupplierPos(selectedsupplierData)
                .unwrap()
                .then((res) => {
                    console.log("Supplier PO Response:", res);
                    const poList = res.message || [];
                    if (poList.length > 0) {
                        const company = poList[0].company;

                        setFields((prev) => ({
                            ...prev,
                            company: company,
                        }));
                    }
                    setSupplierPOs(res.message || []);
                    setPopupOpen(true)
                })
                .catch((err) => {
                    console.error("Error fetching supplier POs:", err);
                });
        } else {
            console.warn("No supplier selected");
        }
    };


    const handleConfirmPOSelection = async (selected) => {
        try {
            const response = await getPOItemsForASN(selected).unwrap();
            console.log("PO Items for ASN:", response);
            setAsnItems(response.message || []);
            // You can save response in a state if needed
            setPopupOpen(false); // Close popup after success
        } catch (error) {
            console.error("Error fetching PO items for ASN:", error);
        }
    };
    // new



    const [fields, setFields] = useState({})
    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [tab, settab] = useState(1)
    const [ptype, setptype] = useState("Error ")
    const [showpopup, setShowpopup] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const [submit, setsubmit] = useState(false);
    const [docstatus, setdocstatus] = useState(false);



    const [fieldErrors, setFieldErrors] = useState({});


    const handleSaveASN = async () => {

        const errors = {};

        if (!fields.posting_date) errors.posting_date = "Posting date is required.";
        if (!fields.estimated_arrival) errors.estimated_arrival = "Estimated arrival is required.";
        if (!fields.company) errors.company = "Company is required.";
        if (!selectedsupplierData) errors.supplier = "Supplier is required.";

        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors);
            setError("Please fill all mandatory fields.");
            setptype("Error");
            setShowError(true);
            return;
        }
        const payload = {
            posting_date: fields.posting_date,
            estimated_arrival: fields.estimated_arrival,
            supplier: selectedsupplierData,
            company: fields.company,
            items: asnItems,
        };

        try {
            console.log(payload, "payload");

            const response = await createASN(payload).unwrap();
            if (response?.data?.asn) {
                setAsnId(response.data.asn);
                setError("Asn Created Successful");
                setptype("Saved");
                setShowError(true);
            }

            console.log("ASN Created:", response);
        } catch (error) {
            console.error("Error creating ASN:", error);
        }
    };

    const handleUpdate = async () => {
        const asnPayload = {
            asn: asnId,
            posting_date: fields.posting_date,
            estimated_arrival: fields.estimated_arrival,
            supplier: selectedsupplierData,
            company: fields.company,
            items: asnItems,
        };
        const response = await updateASN(asnPayload).unwrap();
        setError("Asn Updated Successful");
        setptype("Updated");
        setShowError(true);
        console.log(response);
    };


    const handleSubmitASN = async () => {
        try {
            const response = await submitASN({ asn: asnId }).unwrap();
            console.log("ASN Submitted:", response);
            setError("Asn Submitted Successful");
            setptype("Submitted");
            setShowError(true);
            setsubmit(true)
        } catch (err) {
            console.error("Error submitting ASN:", err);
        }
    };


    const { data: asnDetailData, isSuccess } = useGetASNDetailsQuery(asn_id, {
        skip: !asn_id, // only call if asn_id is provided
    });

    useEffect(() => {
        if (isSuccess && asnDetailData?.data) {
            const res = asnDetailData.data;

            setFields({
                posting_date: res.posting_date || '',
                estimated_arrival: res.estimated_arrival || '',
                company: res.company || '',
                Supplier: res.supplier || '',
            });
            setdocstatus(res.docstatus)

            setAsnItems(res.asn_items || []);
            setselectedSupplierData(res.supplier || '');
            setAsnId(res.name);
            setItem(true);
            setButtonData(res.docstatus === 1);
        }
    }, [isSuccess, asnDetailData]);




    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between " style={{ background: "#fcfdfe", height: '40px', padding: '0px 5px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Inbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/inbound/asn/inboundasn')}>Asn List  </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }} >
                        New Asn Create
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {docstatus == 1 ? 'Submitted' : item ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>

                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    {!submit && docstatus == 0 && (
                        <>
                            {selectedsupplierData && (
                                <Button
                                    className="custom-btn-bluecolor d-flex"
                                    iconName="IoCloudDownload"
                                    style={{ gap: '2px' }}
                                    iconSize={14}
                                    onClick={handleFetchSupplierPOs}
                                >
                                    Get Purchase Order
                                </Button>
                            )}

                            {asnId && (
                                <>
                                    <Button
                                        className="custom-btn-00989"
                                        iconName="LuFilePlus2"
                                        onClick={handleUpdate}
                                        style={{ gap: '2px', height: '28px' }}
                                        iconSize={12}
                                    >
                                        Update
                                    </Button>

                                    <Button
                                        className="custom-btn-00989"
                                        iconName="LuFilePlus2"
                                        onClick={handleSubmitASN}
                                        style={{ gap: '2px', height: '28px' }}
                                        iconSize={12}
                                    >
                                        Submit
                                    </Button>
                                </>
                            )}
                        </>
                    )}



                </div>
            </div>
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul className="nav nav-tabs mb-0" style={{ color: "white", border: "none" }}>
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "3px", color: "#391F84" }}>
                           <Attachment doctype="Advance Shipment Note"  docname={asnId}   />
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    <div className="col-3 sidebarbox" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}>
                        <Tab1 asnId={asnId} fields={fields} setFields={setFields} supplierOptions={supplierOptions} setselectedSupplierData={setselectedSupplierData} fieldErrors={fieldErrors}
                        />
                    </div>
                    {tab == 1 ? <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            <div className="d-flex pb-2" style={{ gap: '5px' }}>
                                {/* <p className="NoOfLine">No.of Lines - <span style={{ color: '#2563EB' }}> {TableData.length}</span></p>
                                <p className="NoOfLine">No.of DeliveryNotes - <span style={{ color: '#2563EB' }}> {selectedDeliveryNotes.length}</span></p>
                                <p className="NoOfLine">No.of SalesInvoices - <span style={{ color: '#2563EB' }}> {selectedSalesInvoices.length}</span></p>
                                <p className="TotalQty">Value of Goods -  <span style={{ color: '#16A34A' }}> {totalVal}</span></p>
                                <p className="TotalQty">Scanned Boxes -  <span style={{ color: '#16A34A' }}> {verifiedCount}</span></p> */}
                            </div>


                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            TableData={asnItems}
                            setTableData={setAsnItems}


                        />
                        {/* here */}
                    </div>
                        : ''}

                </div>
            </div>

            {popupOpen && (
                <PurchaseOrderPopup
                    isOpen={popupOpen}
                    onClose={() => setPopupOpen(false)}
                    data={supplierPOs}
                    selected={selectedPOs}
                    onSelect={setSelectedPOs}
                    handleConfirm={handleConfirmPOSelection}
                />
            )}

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />


        </>
    )
}

export default Asnform 
